import type { RuntimeConfig } from "./types.js";

let cached: RuntimeConfig | undefined;

/** Load runtime config written by CDK at /config.json. No secrets are baked into the bundle. */
export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`Failed to load /config.json (${res.status})`);
  cached = (await res.json()) as RuntimeConfig;
  return cached;
}
